'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { myListShows } from '@/lib/resources/my-list-shows';
import { continueWatching } from '@/lib/resources/continue-watching';
import Link from 'next/link';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';

// lib files
import { ContinueWatchingData, MyListShowsData } from '@/lib/types/api/home-data';
import {
  MyListConfirmModalTypeEnum,
  myListConfirmModalAtom
} from '@/lib/atoms/my-list-confirm-modal';
import { ProfileData } from '@/lib/types/api/profile-data';
import { ShowRowContent } from '@/lib/types/api/show-data';
import { SHOW_ROW_SPLIDE_OPTIONS } from '@/lib/constants';
import { useHasMounted } from '@/lib/hooks';
import { useIdentity } from '@/lib/hooks/useIdentity';

// components
import ContinueWatchingShowPoster from './ContinueWatchingShowPoster';

// styles
import styles from './ContinueWatchingRow.module.scss';

interface ContinueWatchingRowProps {
  profileStub?: ProfileData;
  depIsLoggedIn?: boolean;
  depContinueWatchingData?: ContinueWatchingData["content"];
  depMyListShowsData?: MyListShowsData["content"];
}

export default function ContinueWatchingRow(props: ContinueWatchingRowProps) {
  const { profileStub, depIsLoggedIn, depContinueWatchingData, depMyListShowsData } = props;
  const { isSignedIn } = useIdentity()
  const hasMounted = useHasMounted()
  const [ continueWatchingData, setContinueWatchingData ] = useAtom(continueWatching.itemsAtom);
  const [ myListShowsData, setMyListShowsData ] = useAtom(myListShows.itemsAtom);
  const [ posterWithOpenMenu, setPosterWithOpenMenu ] = useState('');
  const [ _, setConfirmModalState ] = useAtom(myListConfirmModalAtom);

  // Gated on mount because the cached profile is read from localStorage, so the
  // client's first render knows about a session the server's does not. Rendering
  // from identity before mounting is a hydration mismatch. profileStub is a
  // storybook affordance, not real identity, so it is called out separately.
  const isLoggedIn = depIsLoggedIn === true || (hasMounted && isSignedIn) || !!profileStub

  const handleRemoveShowClick = async (show: ShowRowContent, event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const modalState = {
      id: show.cid,
      isOpen: true,
      slug: show.slug,
      title: show.title,
      type: MyListConfirmModalTypeEnum.SHOW,
    }
    setConfirmModalState(modalState);
  }

  // Set data for storybook
  useEffect(() => {
    if (isLoggedIn) {
      if (depContinueWatchingData) {
        setContinueWatchingData(depContinueWatchingData)
      }
      if (depMyListShowsData) {
        setMyListShowsData(depMyListShowsData)
      }
    }
  }, [isLoggedIn, depContinueWatchingData, depMyListShowsData, setContinueWatchingData, setMyListShowsData]);

  const options = {
    ...SHOW_ROW_SPLIDE_OPTIONS,
    classes: {
      arrow: `splide__arrow ${styles.continue_watching_row__splide_arrow}`
    }
  }

  return ( isLoggedIn && (continueWatchingData || myListShowsData) ? (
    <div className={styles.continue_watching_row}>
      <h3>
        <Link
          href={"/my-list-viewing-history/"}
          className={styles.continue_watching_row__title}
        >
          Continue Watching
        </Link>
      </h3>

      <Splide aria-label='Continue Watching Row' options={options} >
        {continueWatchingData?.map((video, index) => (
          <SplideSlide key={index}  className={styles.splide__slide}>
            <ContinueWatchingShowPoster
              show={video.show}
              type={'continueWatching'}
              video={video}
              isOpen={video.title === posterWithOpenMenu}
              setPosterWithOpenMenu={setPosterWithOpenMenu}
            />
          </SplideSlide>
        ))}
        {myListShowsData?.map((show, index) => {
          return (
            <SplideSlide key={index} className={styles.splide__slide}>
              <ContinueWatchingShowPoster
                show={show as ShowRowContent}
                type={'myListShow'}
                isOpen={show.title === posterWithOpenMenu}
                setPosterWithOpenMenu={setPosterWithOpenMenu}
                handleRemoveShowClick={handleRemoveShowClick}
              />
            </SplideSlide>
          )})}
      </Splide>
    </div>
  ) : null )
}
